import {
    ATTACHMENT_ENTITY_TYPES,
    getAttachmentEntityConfig,
} from './attachmentEntityConfig';
import { openAttachmentsPopup } from './attachmentsPopup';

export const MONEY_CODE_ATTACHMENTS_POPUP_KIND =
    getAttachmentEntityConfig(ATTACHMENT_ENTITY_TYPES.MONEY_CODE).popupKind;

export function openMoneyCodeAttachmentsPopup({ moneyCode, canEdit, onMoneyCodeUpdated }) {
    const titleLabel =
        moneyCode?.efsCode != null && String(moneyCode.efsCode).trim() !== ''
            ? String(moneyCode.efsCode)
            : moneyCode?.id != null
              ? String(moneyCode.id)
              : '';
    openAttachmentsPopup({
        entityType: ATTACHMENT_ENTITY_TYPES.MONEY_CODE,
        entity: moneyCode,
        titleLabel,
        canEdit,
        onEntityUpdated: onMoneyCodeUpdated,
        popupKind: MONEY_CODE_ATTACHMENTS_POPUP_KIND,
    });
}
